import { Divider, Modal } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { CredusButton, CredusText, CredusWrapper } from 'ui';

interface ConfirmModalProps {
  setSubmission: React.Dispatch<React.SetStateAction<boolean>>;
  submission: boolean;
  onConfirmModalOpen: () => void;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  onConfirmModalOpen,
  setSubmission,
  submission,
}) => {
  return (
    <>
      <Modal
        centered
        title={
          <>
            <CredusText size="md" weight="medium">
              Confirm Action
            </CredusText>
          </>
        }
        open={submission}
        footer={false}
        onOk={() => setSubmission(false)}
        onCancel={() => setSubmission(false)}
        width={480}
      >
        <Divider style={{ margin: '29px 0px 0px' }} />
        <Container>
          <NotifyWrap>
            <CredusText size="lg" weight="regular" align="center">
              You’re about <BoldText>Upload</BoldText> this candidate result
              record. Kindly confirm you’re aware of this action
            </CredusText>
          </NotifyWrap>
          <CredusWrapper mt=".8rem" display="flex" justify="center">
            <CredusWrapper mb="4rem" display="flex" gap="1.4rem">
              <CredusButton onClick={onConfirmModalOpen} variant="primary">
                Yes, I confirm
              </CredusButton>
              <CredusButton onClick={onConfirmModalOpen} variant="secondary">
                Cancel
              </CredusButton>
            </CredusWrapper>
          </CredusWrapper>
        </Container>
      </Modal>
    </>
  );
};

export default ConfirmModal;

const Container = styled.div`
  padding: 0rem 0.8rem;
`;

const NotifyWrap = styled.div`
  margin-top: 49px;
  margin-bottom: 69px;
  text-align: center;
`;
const BoldText = styled.span`
  font-weight: 500;
`;
